import script from "./consolidated-payment-step2.vue?vue&type=script&setup=true&lang=ts"
export * from "./consolidated-payment-step2.vue?vue&type=script&setup=true&lang=ts"

import "./consolidated-payment-step2.vue?vue&type=style&index=0&id=56f46c25&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56f46c25"]])

export default __exports__